/* eslint-disable camelcase */
export type BetRadarResponse = {
    stream_url: string;
    stream_id: string;
};

export type BetRadarError = {
    message: string;
    code: string;
};

export function isBetRadarError(input: BetRadarResponse | BetRadarError): input is BetRadarError {
    return Boolean((input as BetRadarError).code && (input as BetRadarError).message);
}
